import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { BrComService } from '../../service/BrComService';
import { Network } from '@ionic-native/network';

var denunciaDetalhesPageInstance: DenunciaDetalhesPage;

interface localizacao {
  latitute: number,
  longitude: number,
  endereco: string
}

interface denuncia {
  idDenunciaServidor: string,
  codEmpresa: number,
  codUsuario: number,
  titulo: string,
  observacao: string,
  fotos: string[],
  local: localizacao,
  timestamp: any
}

enum collecaoFirestore {
  USUARIO = "usuario",
  DENUNCIAS = "denuncias",
  FOTOS = "fotos"
}

@Component({
  selector: 'page-denunciadetalhes',
  templateUrl: 'denunciadetalhes.html'
})

@Component({
  selector: 'page-denunciaregistro',
  template: `<textarea fz-elastic></textarea>`
})

export class DenunciaDetalhesPage {

  public titulo: string;
  public data: string;
  public observacao: string;
  public local: string;
  public fotos: string[];

  constructor(private navParams: NavParams, private network: Network, private brComService: BrComService){
    denunciaDetalhesPageInstance = this;
    const denuncia = this.navParams.get("denuncia");
    this.titulo = "";
    this.data = "";
    this.observacao = "";
    this.local = "";
    this.fotos = [];
    denunciaDetalhesPageInstance.montarVariaveisDenuncia(denuncia);
  }

  private montarVariaveisDenuncia(denuncia: denuncia) {
    denunciaDetalhesPageInstance.titulo = denuncia.titulo;
    denunciaDetalhesPageInstance.data = denunciaDetalhesPageInstance.brComService.converterTimestampParaDataComHorarioString(denuncia.timestamp);
    denunciaDetalhesPageInstance.observacao = denuncia.observacao;
    denunciaDetalhesPageInstance.local = denuncia.local.endereco;
    denunciaDetalhesPageInstance.fotos = denunciaDetalhesPageInstance.montarFotosParaVisualizacao(denuncia.fotos);
  }

  public isFotosVazia():boolean {
    if(denunciaDetalhesPageInstance.getFotosDenuncia().length > 0) {
      return false;
    }
    return true;
  }

  public getFotosDenuncia():string[]{
    return denunciaDetalhesPageInstance.fotos
  }

  private getCaminhoDenunciasUsuario(idUsuarioServidor: string):string {
    return `${collecaoFirestore.USUARIO}/${idUsuarioServidor}/${collecaoFirestore.DENUNCIAS}`;
  }

  private montarFotosParaVisualizacao(fotos: string[]):string[] {
    let fotosFormatadas = []
    for (const foto of fotos) {
      fotosFormatadas.push(denunciaDetalhesPageInstance.montarFotoParaVisualizacao(foto));
    }
    return fotosFormatadas;
  }

  private montarFotoParaVisualizacao(foto: string):string {
    const codificadorImagemJPEGBase64 = "data:image/jpeg;base64,";
    const imagem64 = foto;

    return codificadorImagemJPEGBase64 + imagem64;
  }

  public isObservacaoVazia():boolean {
    if (denunciaDetalhesPageInstance.observacao != "") {
      return false;
    }
    return true;
  }

  public isListaFotosVazia():boolean {
    if (denunciaDetalhesPageInstance.getFotosDenuncia().length > 0) {
      return false;
    }
    return true
  }

  public isConectadoInternet():boolean {
    const tipoSemConexao = "none";
    if (denunciaDetalhesPageInstance.network.type != tipoSemConexao) { 
      return true;
    }
    return false;
  }

}


// WEBPACK FOOTER //
// ./src/pages/denunciadetalhes/denunciadetalhes.ts